import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"
import "./style.css"
import NRTFormInput from "../../../_common/_form/FormInput"
import NRTFormStateManager from "../../../_common/_form/FormStateManager"
import NRTVerticalStack from "../../../_common/_containers/VerticalStack"
import MCEadInputLabel from "../../InputLabel"
import MCEadContentCard from "../../ContentCard"
import FileRequests from "../../../../requests/file-requests"
import {getS3Key} from "../../../../helpers/aws"
import moment from "moment/moment"
import MCLoadingOverlay from "../../../_minha-central/LoadingOverlay"
import EadRequests from "../../../../requests/ead-requests"
import {Validators} from "../../../_common/_form/Validators"
import NRTFormErrorMsg from "../../../_common/_form/FormErrorMsg"
import MCEadTitle from "../../Title"
import ButtonWithChevron from "../../../_minha-central/ButtonWithChevron"

class MCEADContentFile extends Component {

    SIMULATE_SEND_FILE_ERROR = false
    SIMULATE_FIND_FILE_ERROR = false
    TUTOR_FORUM_CODE = 1

    state = {
        initialized: false,
        awaiting: true,
        file: null,
        post: null,
        tutorForm: {},
    }


    componentDidUpdate(prevProps, prevState) {
        if (this.props.cntCode != prevProps.cntCode) {
            this.fileRequest()
        }
    }

    componentDidMount() {
        this.fileRequest()
    }

    fileRequest = () => {

        const searchTopic = EadRequests.searchTutorTopics({
            prsCode: this.props.context.person.code,
            cntCode: this.props.cntCode
        })

        searchTopic
            .then((result) => {
                const hasTopic = !!result.forumtopic && result.forumtopic.length > 0

                const req = this.SIMULATE_FIND_FILE_ERROR ?
                    Promise.reject("SIMULATE_FIND_FILE_ERROR") :
                    FileRequests
                        .search({
                            entityClass: "br.com.nerit.entity.model.ead.EadContent",
                            entityCode: this.props.cntCode,
                            empPersonCode: this.props.context.person.code
                        })

                const postReq = hasTopic ? EadRequests
                    .searchForumPosts({
                        ftpCode: result.forumtopic[0].code,
                        prsCode: this.props.context.person.code,
                        orderByClause: 's.postDate'
                    }) : null

                return Promise.all([req, postReq])
            })
            .then(([resultFile, posts]) => {

                let post = null
                if (!!posts) {
                    post = posts.forumpost.filter(p => !p.fileUrl)[0]
                }

                this.setState({
                    initialized: true,
                    awaiting: false,
                    file: resultFile.file[0],
                    person: this.props.context.person.code,
                    post,
                })
            })
            .catch(error => {
                this.setState({awaiting: false})
                this.props.onError(error, "Ocorreu um erro inesperado.", {method: "componentDidMount()"})
            })
    }


    fileChanged = async (formFile) => {

        if (!(formFile &&
            formFile.valid &&
            formFile.values.file))
            return

        const fileUrl = formFile.values.file
        const fileName = decodeURIComponent(fileUrl).substring(fileUrl.lastIndexOf("/") + 1)

        const req = this.SIMULATE_SEND_FILE_ERROR ?
            Promise.reject("SIMULATE_SEND_FILE_ERROR") :
            FileRequests
                .save({
                    category: 2, //Documentos
                    date: moment(),
                    entityClass: "br.com.nerit.entity.model.ead.EadContent",
                    entityCode: this.props.cntCode,
                    path: getS3Key(fileUrl),
                    prsCode: this.props.context.person.code,
                    title: fileName,
                    url: fileUrl
                })

        req
            .then(async result => {
                if (result.success) {
                    const elemDOM = document.querySelector(".master")
                    elemDOM.scrollTop = 0

                    const tutorExpired = !!this.props.maxTutorDate && moment().isAfter(this.props.maxTutorDate)
                    if (this.props.hasTutor && !tutorExpired)
                        await this.sendPostTutor(fileUrl, fileName)

                    this.props.context.set({
                        toastMessage: {
                            type: "success",
                            content: "Arquivo enviado com sucesso."
                        }
                    })
                } else {

                    this.props.onError(
                        {msg: "result.success === false"},
                        "Ocorreu um erro ao enviar o arquivo. Recarregue a página e tente novamente. Caso o erro persista, entre em contato conosco.",
                        {method: "fileChanged()"}
                    )
                }
            })
            .catch(error => {

                this.props.onError(error,
                    "Ocorreu um erro ao enviar o arquivo. Recarregue a página e tente novamente. Caso o erro persista, entre em contato conosco.",
                    {method: "fileChanged()"}
                )

            })
    }

    sendPostTutor = async (file, fileName) => {
        const person = this.props.context.person

        const searchTopic = await EadRequests.searchTutorTopics({
            prsCode: person.code,
            cntCode: this.props.cntCode
        })

        let topic = null
        if (!searchTopic.forumtopic || searchTopic.forumtopic.length === 0) {

            // Cria topico da tutoria
            topic = await EadRequests.saveForumTopic({
                prlCode: this.props.release.code,
                prsCodeCreation: person.code,
                ftpTitle: `Tutoria ${person.code} - ${this.props.cntCode}`,
                fomCode: this.TUTOR_FORUM_CODE,
                cntCode: this.props.cntCode,
            })

            if (!topic.success) {
                return
            }
        } else {
            topic = searchTopic.forumtopic[0]
        }

        const forumPostDTO = {
            forumTopicDTO: topic,
            personPostCode: person.code,
            personPostName: person.name,
            personTypesPost: person.types,
            fileUrl: file,
            postDate: moment(),
            post: fileName
        }

        return await EadRequests.saveForumPost(forumPostDTO)
    }

    onFormMessageChange = (form) => {
        this.setState({tutorForm: form})
    }

    submitTutorMsg = async () => {
        const message = this.state.tutorForm.values.message

        if (!message) {
            console.log("invalido")
            return null
        }

        await this.sendPostTutor(null, message)

        this.props.context.set({
            toastMessage: {
                type: "success",
                content: "Mensagem enviada com sucesso."
            }
        })

        this.setState({
            post: {post: message}
        })
    }

    render() {

        const {release, message} = this.props
        const {
            file,
            initialized, awaiting,
            post
        } = this.state

        const messageSent = post ? post.post : null
        const tutorExpired = !!this.props.maxTutorDate && moment().isAfter(this.props.maxTutorDate)
        const msg = `Data Limite: ${moment(this.props.maxTutorDate).format('DD/MM/YYYY HH:mm')}. 
                    ${tutorExpired ? 'Prazo para realização expirado.' : '(' + moment(this.props.maxTutorDate).fromNow(true) + ' restante(s)).'}`

        return (

            <MCEadContentCard style={{"minHeight": "200px"}}>
                <MCLoadingOverlay show={awaiting}/>
                <div style={{width: "100%"}}>
                    <NRTFormStateManager ref={f => this.formFile = f}
                                         onStateChange={this.fileChanged}>

                        {
                            initialized ?
                                (
                                    <NRTVerticalStack>

                                        <MCEadInputLabel
                                            text={"Instruções:"}
                                            style={{
                                                padding: "0 0 0.7rem 1rem"
                                            }}/>
                                        {
                                            message &&
                                            <div
                                                style={{
                                                    padding: "1rem",
                                                    border: "1px solid #dedede",
                                                    marginBottom: "1rem"
                                                }}
                                                dangerouslySetInnerHTML={{__html: message}}
                                            />
                                        }


                                        <div style={{maxWidth: 450, margin: "1rem auto 0 auto"}}>
                                            <NRTFormInput
                                                name={"file"}
                                                type={"file"}
                                                customClass={"nrt-file-input-container nrt-upload-file-class"}
                                                customProps={{
                                                    shouldUploadToS3: true,
                                                    s3ParentType: `Versao/${release.code}/arquivos`,
                                                    disabled: !!file
                                                }}
                                            />

                                            {
                                                file &&
                                                <a href={file.url} download={file.title}>{file.title}</a>
                                            }
                                        </div>

                                        {
                                            this.props.hasTutor &&
                                            <Fragment>
                                                <MCEadTitle style={{marginBottom: '0.8rem'}} title={'Tutoria'} small/>
                                                {
                                                    this.props.maxTutorDate && <NRTFormErrorMsg msg={msg}/>
                                                }

                                                <div style={{width: "100%"}}>
                                                    <NRTFormStateManager ref={f => this.form = f}
                                                                         onStateChange={this.onFormMessageChange} debug>
                                                        <NRTVerticalStack>
                                                            <NRTFormInput
                                                                ref={(input) => this.textMessage = input}
                                                                value={messageSent}
                                                                disabled={messageSent || tutorExpired}
                                                                type={'textarea'}
                                                                name={'message'}
                                                                validators={[
                                                                    Validators.required()
                                                                ]}
                                                                customProps={{rows: '15'}}
                                                            />

                                                            <ButtonWithChevron buttonLabel={'Enviar'}
                                                                               secondary
                                                                               onClick={this.submitTutorMsg}
                                                                               disabled={this.state.tutorForm.valid === false || messageSent || tutorExpired}
                                                                               style={{margin: "0 auto"}}
                                                            />
                                                        </NRTVerticalStack>
                                                    </NRTFormStateManager>
                                                </div>
                                            </Fragment>
                                        }
                                    </NRTVerticalStack>
                                )
                                : null
                        }
                    </NRTFormStateManager>
                </div>
            </MCEadContentCard>
        )
    }
}


MCEADContentFile.propTypes = {
    hasTutor: PropTypes.bool,
    release: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
    cntCode: PropTypes.any.isRequired,
    message: PropTypes.string.isRequired

}

MCEADContentFile.defaultProps = {}


export default MCEADContentFile



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/File/index.js